import "../styles/application.scss";
import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap";
import "../controllers";

window.bootstrap = bootstrap;
